<template>
  <div>
    <share :shareInfo="shareInfo"/>
    <a class="share-icon" @click="isShow = !isShow" v-if="showIcon && os.isClient" :style="icon ? {backgroundImage:shareIcon} : ''"></a>
    <tme-dialog :show="isShow">
      <i class="icon-close" @click="isShow = false"></i>
      <div class="t-content-main">
        <div class="noTickNum block">
          <h1>分享文章<br/>邀好友来一起定义流行</h1>
          <!-- <div class="tip">邀好友来一起定义流行</div> -->
          <ul class="platform">
            <li @click="platforms.wx = true;isShow = false;">
              <img src="./img/logo_weixin.png" alt="">
            </li>
            <li @click="platforms.wx = true;isShow = false;">
              <img src="./img/logo_weixin_pyq.png" alt="">
            </li>
            <li @click="share('qq')">
              <img src="./img/logo_qq.png" alt="">
            </li>
            <li @click="share('qq_zone')">
              <img src="./img/logo_qq_zone.png" alt="">
            </li>
            <li v-if="!isWeixin && !isQQ" @click="share('sina')">
              <img src="./img/logo_weibo.png" alt="">
            </li>
          </ul>
        </div>
      </div>
    </tme-dialog>
    <tme-dialog :show="platforms.wx">
      <i class="icon-close" @click="platforms.wx = false; isShow=true"></i>
      <div class="t-content-main">
        <div class="vote-img">
          <div class="line"></div>
          <div id="qrcode">
            <!-- <img src="~@assets/imgs/qrcode.png" alt=""> -->
          </div> 
        </div>
        <div class="noTickNum block">
          <h1>分享文章<br/>邀好友来一起定义流行</h1>
        </div>
      </div>
    </tme-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import tmeDialog from './component/dialog.vue'
import os from './utils/os'
import handleShare from './utils/handle'

// import QRCode from './libs/qrcode.min.js'
require('./libs/qrcode.min.js')




export default {
  components: {
    tmeDialog,
    share: () => import('./component/share.vue')
  },
  props: {
    // 分享内容
    shareInfo: {
      type: Object,
      default: {}
    },
    // 显示分享平台
    show: {
      type: Boolean
    },
    // 是否显示图标
    icon: {
      default: false
    }
  },
  updated() {
    
  },
  computed: {
    // 分享图标url
    shareIcon() {
      let url = ''
      if(this.icon && typeof this.icon == 'string'){
        url = this.icon
      }else{
        url = 'url('+require('./img/share.png')+')'
      }
      return url
    },
    // 是否显示分享图标
    showIcon() {
      if(os.isQQMusic){
        return false
      }
      if(this.icon){
        return true
      }else{
        return false
      }
    }
  },
  data() {
    return {
      os,
      isWeixin: os.isWeixin,
      isQQ: os.isQQ,
      qrcodeData: '', // 二维码
      isShow: this.show, // 显示分享弹窗
      platforms: {
        wx: false
      }
    }
  },
  methods: {
    // 分享
    share(type) {
      handleShare(this.shareInfo, type)
    },
    // 二维码生成
    qrcode () {
      if(this.qrcodeData){
        console.log('已存在')
        return
      }
      let url = window.location.href
      // let url = 'http://tmesit.tencent.com'
      this.qrcodeData = new QRCode('qrcode', {
        width: 133,
        height: 133, // 高度
        text: url // 二维码内容
      })
    }
  },
  mounted() {
    
  },
  watch: {
    show (n,o) {
      this.isShow = n
    }
  }
}
</script>

<style lang="less" scoped>
  // 分享
  .share-icon{
    display: block;
    position: absolute;
    top: 10%;
    right: 0;
    height: 50px;
    width: 50px;
    margin-top: -25px;
    background-repeat:no-repeat;
    background-position: center center;
    background-size:100%;
  }
  i.icon-close{
    width: 0.93333rem;
    height: 0.93333rem;
    position: absolute;
    left: 50%;
    margin-left: -0.46667rem;
    bottom: -1.86667rem;
    background: url('./img/icon_dialogue_x.png') center center no-repeat;
    background-size: contain;
  }
  .t-content-main{
    width: 7.89333rem;
    height: auto;
    margin: 0 auto auto auto;
    border-radius: 0.32rem;
    background-color: #FFF;
    position: relative;
    overflow: hidden;
  }
  .noTickNum{
    // display: none;
    h1{
      font-size: 36px;
      line-height: 50px;
      font-weight: normal;
      color: #343434;
      letter-spacing: -1.5px;
      margin-top: 70px;
      margin-bottom: 48px;
    }
    h2{
      margin-bottom: 13px;
      font-size: 24px;
      opacity: 0.6;
    }
    div{
      opacity: 0.6;
      strong{
        opacity: 1;
        font-weight: bold;
      }
    }
    font-size: 24px;
    ul.platform{
      font-size: 0px;
      width: 100%;
      bottom: 94px;
      padding-top: 0px;
      margin-bottom: 50px;
      > li {
        display: inline-block;
        width: 80px;
        height: 80px;
        vertical-align: middle;
        &:not(:last-child) {
          margin-right: 26px;
        }
        img{
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
  }
  .vote-img{
    width: 100%;
    background-color: #FCFCFC;
    height: 300px;
    padding-top: 50px;
    position: relative;
    #qrcode{
      display: block;
      width: 241px;
      height: 241px;
      border-radius: 10px;
      margin: 0 auto;
      background: url('./img/qrcode.png') no-repeat center center;
      background-size: contain;
      > canvas,img{
        display: block;
        width:100%!important;
        height:100%!important;
      }
    }
    img{
      display: block;
      width: 241px;
      height: 241px;
      border-radius: 10px;
      margin: 0 auto;
    }
    .title{
      h2{
        font-size: 32px;
        line-height: 45px;
        margin-top: 26px;
        color: #343434;
      }
      .sub-title{
        margin-top: 10px;
        font-size: 24px;
        color: #343434;
        letter-spacing: -1px;
        line-height: 24px;
        opacity: .6;
      }
    }
    .line{
      position: absolute;
      height: 38px;
      bottom: 0;
      width: 100%;
      height: 38px;
      background-image: linear-gradient(-180deg, #FCFCFC 0%, #D8D8D8 100%);
      opacity: .3;
    }
  }
</style>
